import { format } from 'date-fns';
/* Use date-fns instead of moment going forward.  It is a lighter library.
 https://momentjs.com/docs/#/-project-status/
 */

export const formatDate = (date?: string | Date) => {
  return date ? format(new Date(date), 'MMM dd, yyyy hh:mm a (z)') : undefined;
};
